import { authorize, getRequest } from 'utils/http';
import { AWS_API_URL } from 'global/environment';

export async function getAllUsersAPI() {
  const url = `${AWS_API_URL}/admin/users`;

  const data = await getRequest(url, await authorize());
  return data.users || [];
}
